export default __webpack_public_path__ + "static/tree-cameraRaw-beige-h348-e1ed891fe758b203d596036f2f2f4904.png";